var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"titleBox"},[_c('p',{staticClass:"bigTitle"},[_vm._v(_vm._s(_vm.bigTitle))]),_c('p',{staticClass:"thinTitle"},[_vm._v(_vm._s(_vm.thinTitle))])]),_c('div',{staticClass:"imgBox2"},[_c('img',{attrs:{"src":_vm.imgList[0]}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }